export const blockIconsHomeNestThermostatGen3New = (
	<span className='material-symbols-outlined'>nest_thermostat_gen_3</span>
);
